exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-reminder select[data-v-63ac80ac]{background:transparent;color:#fff;margin-bottom:.5rem}.service-reminder--booked[data-v-63ac80ac]{background:red;color:#fff}.service-reminder--ok[data-v-63ac80ac]{background:#ff0;color:#000}.service-reminder--done[data-v-63ac80ac]{background:green;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63ac80ac","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/office/service-reminders/IndexComponent.vue
// module id = XM2b
// module chunks = 0